import React, { Component } from "react";

export default class SectionHeader extends Component {
  render() {
    let { heading, textAlignClass, rowStyle } = this.props;
    return (
      <div
        className="row border border-dark grey"
        style={rowStyle ? rowStyle : {}}
      >
        <div className="col-lg-12">
          <div className={`${textAlignClass} py-4 font-weight-bold fs-19`}>
            {heading}
          </div>
        </div>
      </div>
    );
  }
}
